/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Label } from "..";
import { Flex } from "../utilities";
import { SwitchBase } from "./Switch.base";
import type { SwitchBaseProps, SwitchProps } from "./Switch.types";

export const Switch = ({
  className,
  onChange,
  sx,
  isChecked,
  label,
  labelProps,
  isDisabled,
  as,
  native,
}: SwitchProps) => {
  return (
    <Flex
      className={className}
      justifyContent="space-between"
      gap={vars.spacing[3]}
      padding={`${vars.spacing[1]} 0`}
      sx={sx}
      as={as}
      native={native}
    >
      <Label text={label} sx={{ flex: 1 }} {...labelProps} />

      <SwitchBase isChecked={isChecked} onChange={onChange} isDisabled={isDisabled} />
    </Flex>
  );
};

Switch.Base = (props: SwitchBaseProps) => <SwitchBase {...props} />;
